// extracted by mini-css-extract-plugin
module.exports = {"plansPage":"page_plansPage__pytRz","background":"page_background__DPHjh","trustedBy":"page_trustedBy__XlbYa"};